export const environment = {
    production: false,
    apiUrl: 'https://dagpacket-backend.onrender.com/api/v1',	
    googleApi: 'AIzaSyAauNhkAgl2vnaD4U4xojIC_RFE9lkUmoA',
    
  };
  // http://localhost:3000/api/v1'
  // https://dagpacket-backend.onrender.com/api/v1